import { Step } from "react-joyride";
import { I18N } from "oc-I18N";
import { Joyrider } from "../../commons/Joyrider";

export function JoyrideTour({ page }) {
  const grundrissSteps = [
    {
      target: ".grundform-button",
      content: I18N("tour_grundriss::Auswahl zwischen mehreren Grundformen und freiem Zeichnen"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".tool-buttons",
      content: I18N(
        "tour_grundriss::Werkzeug-Buttons zum zeichnen, radieren, verschieben und selektieren der Grundrisslinien"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".aufbauten-menu",
      content: I18N(
        "tour_grundriss::Hiermit können Aufbauten und Tore zum Grundriss hinzugefügt werden. Die Tore müssen auf den Zaunlinien platziert werden"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".undo-redo-buttons",
      content: I18N(
        "tour_grundriss::Mit den beiden Buttons lassen sich Änderungen rückgängig machen oder wieder herstellen"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".zoom-menu",
      content: I18N(
        "tour_grundriss::Analog zum Mausrad kann mit hiermit die Szene vergößert oder verkleinert werden"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".right-menu",
      content: I18N(
        "tour_grundriss::Hier kann zwischen verschiedenen Verteilungsalgorithmen gewählt werden"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".input-label-group",
      content: I18N(
        "tour_grundriss::Über das Input-Feld lassen sich die Maße der Grundrisslinien anpassen"
      ),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".breadcrumbs",
      content: I18N(
        "tour_grundriss::Hiermit können Sie zu vorherigen Seiten zurückkehren, um z.B. den Grundriss zu verändern"
      ),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "body",
      content: I18N("tour_grundriss::Viel Spaß beim Konfigurieren Ihrer Zaunanlage!"),
      placement: "center",
      disableBeacon: true,
    },
  ] as Step[];
  const zauneditorSteps = [
    {
      target: ".fuellung-menu",
      content: I18N(
        "tour::Ändert das Material der Zaunelemente (oder des selektierten Elementes)"
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".scene-overlay",
      content: I18N("tour::Ein Klick auf ein Zaunteil selektiert es"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".editor-optionen",
      content: I18N("tour::Ändert die Form eines Elementes, oder setzt ein Tor ein"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".scene-buttons",
      content: I18N("tour::Diese Buttons helfen beim Bedienen der 3D Szene"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".breadcrumbs",
      content: I18N(
        "tour::Hiermit können Sie zu vorherigen Seiten zurückkehren, um z.B. den Grundriss zu verändern"
      ),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "body",
      content: I18N("tour::Viel Spaß beim Konfigurieren Ihrer Zaunanlage!"),
      placement: "center",
      disableBeacon: true,
    },
  ] as Step[];

  const STEPS = page === "grundriss" ? grundrissSteps : zauneditorSteps;

  if (!APP.ready || localStorage["mouseTutorialShown"] == null) {
    return null;
  }

  const stepIndex = APP.joyrideTourStep[page];
  if (stepIndex < 0) {
    return null;
  }

  return (
    <Joyrider
      width="25em"
      disableScrollParentFix={true}
      steps={STEPS}
      stepIndex={stepIndex}
      setStepIndex={(stepIndex: number) => {
        APP.joyrideTourStep = { ...APP.joyrideTourStep, [page]: stepIndex };
        APP.dirty();
      }}
    />
  );
}
